import React from "react";

import styling from "Services/styling";

export default () => (
	<svg viewBox="0 0 70 40">
		<path
			d="M64.14,5.86 L61.32,8.68 C64.2,11.58 66,15.58 66,20 C66,28.84 58.84,36 50,36 C41.16,36 34,28.84 34,20 C34,11.84 40.1,5.12 48,4.142 L48,8.18 C42.32,9.142 38,14.062 38,20 C38,26.62 43.38,32 50,32 C56.62,32 62,26.62 62,20 C62,16.68 60.66,13.68 58.48,11.52 L55.66,14.34 C57.1,15.802 58,17.802 58,20 C58,24.42 54.42,28 50,28 C45.58,28 42,24.42 42,20 C42,16.28 44.56,13.18 48,12.28 L48,16.562 C46.8,17.26 46,18.52 46,20 C46,22.2 47.8,24 50,24 C52.2,24 54,22.2 54,20 C54,18.52 53.2,17.24 52,16.562 L52,0 L50,0 C38.96,0 30,8.962 30,20 C30,31.04 38.96,40 50,40 C61.04,40 70,31.04 70,20 C70,14.482 67.76,9.482 64.14,5.86"
			fill={styling.colors.primary}
		/>
		<path
			d="M21.1111111,8.88888889 L17.7777778,8.88888889 L17.7777778,22.2222222 L28.3333333,28.5555556 L30,25.82 L21.1111111,20.5555556 L21.1111111,8.88888889 Z M20,35.5555556 C11.4,35.5555556 4.44444444,28.5977778 4.44444444,20 C4.44444444,11.4 11.4,4.44444444 20,4.44444444 C28.6,4.44444444 35.5555556,11.4 35.5555556,20 C35.5555556,28.5977778 28.6,35.5555556 20,35.5555556 L20,35.5555556 Z M20,0 C8.95555556,0 0,8.95333333 0,20 C0,31.0444444 8.93333333,40 20,40 C31.0444444,40 40,31.0444444 40,20 C40,8.95333333 31.0444444,0 20,0 L20,0 Z"
			fill={styling.colors.iconSecondary}
		/>
	</svg>
);
